import { Checkbox } from '@/shared/ui';

interface DoubleBorderCheckboxProps {
    testId: string;
    checked: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
    checkboxClassName?: string;
    children: React.ReactNode;
    name?: string;
    disabled?: boolean;
}

const DoubleBorderCheckbox = ({
    testId,
    checked,
    onChange,
    className,
    checkboxClassName,
    children,
    name = 'terms',
    disabled = false,
}: DoubleBorderCheckboxProps) => {
    return (
        <div className={`border-[3px] rounded-2xl border-mint-400 ${className ? ` ${className}` : ''}`}>
            <Checkbox
                testId={testId}
                uncheckedStrokeColor='#9FA4A1'
                className={`!items-center !gap-5 login__terms border py-[20px] px-[24px] rounded-[14px] border-primary-700 w-full${checkboxClassName ? ` ${checkboxClassName}` : ''}`}
                label={children}
                disabled={disabled}
                name={name}
                checked={checked}
                onChange={onChange}
            />
        </div>
    );
};

export default DoubleBorderCheckbox;
